import { render } from "./UnitScreeningForm.vue?vue&type=template&id=27f4a46d"
import script from "./UnitScreeningForm.vue?vue&type=script&lang=js"
export * from "./UnitScreeningForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__